import type { SupplierStatus } from "../../../../../types/api.types";
import { SUPPLIER_STATUS_OPTIONS } from "../../PersonForm.constants";

/**
 * Returns the label for a given SupplierStatus.
 */
function getSupplierStatusLabel(status: SupplierStatus): string {
  for (const option of SUPPLIER_STATUS_OPTIONS) {
    if (
      typeof option === "object" &&
      "value" in option &&
      option.value === status
    ) {
      return option.label;
    }
  }

  return status;
}

export { getSupplierStatusLabel };
